import { validateSync } from 'class-validator';
import { action, makeObservable, observable } from 'mobx';
export class ObservableForm {
    constructor(Class) {
        this.values = {};
        this.errors = {};
        this.formConstructor = Class;
        this.originalForm = new Class();
        this.form = new Class();
        this.values = Object.assign({}, this.form);
        this.isDirty = false;
        this.hasError = false;
        this.isValid = !(validateSync(this.form).length > 0);
        makeObservable(this, {
            values: observable,
            errors: observable,
            setValue: action,
            setValueAndValidate: action,
            validateField: action,
            validate: action,
            updateState: action,
            reset: action,
            isDirty: observable,
            isValid: observable,
            hasError: observable,
        });
        this.softValidate();
    }
    setValue(fieldName, value) {
        this.form[fieldName] = value;
        this.values = Object.assign(Object.assign({}, this.values), { [fieldName]: value });
        this.softValidate();
    }
    setValueAndValidate(fieldName, value) {
        this.setValue(fieldName, value);
        this.validateField(fieldName);
    }
    validateField(fieldName) {
        this.errors = Object.assign(Object.assign({}, this.errors), { [fieldName]: [] });
        const fieldErrors = validateSync(this.form, {
            validationError: { target: false },
        });
        for (const error of fieldErrors) {
            if (error.property !== fieldName) {
                continue;
            }
            Object.keys(error.constraints).forEach((key) => {
                this.errors[fieldName] = this.errors[fieldName] || [];
                this.errors = Object.assign(Object.assign({}, this.errors), { [fieldName]: [...this.errors[fieldName], error.constraints[key]] });
            });
        }
        this.updateState();
    }
    validate() {
        const fieldErrors = validateSync(this.form, {
            validationError: { target: false },
        });
        for (const error of fieldErrors) {
            Object.keys(error.constraints).forEach((key) => {
                this.errors[error.property] = this.errors[error.property] || [];
                this.errors = Object.assign(Object.assign({}, this.errors), { [error.property]: [...this.errors[error.property], error.constraints[key]] });
            });
        }
        this.updateState();
    }
    softValidate() {
        this.isValid = !(validateSync(this.form).length > 0);
    }
    reset() {
        this.form = new this.formConstructor();
        this.values = Object.assign({}, this.form);
        this.errors = {};
        this.softValidate();
    }
    updateState() {
        this.hasError = Object.keys(this.errors).some((key) => this.errors[key].length > 0);
        this.isDirty = JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
        this.isValid = !(validateSync(this.form).length > 0);
    }
}
